import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ToastModule } from "primeng/toast";

@Component({
	imports: [RouterModule, ToastModule],
	selector: "app-root",
	templateUrl: "./app.html",
	styleUrl: "./app.css",
})
export class App {
	protected title = "portal-frontend";
}
